import { render, staticRenderFns } from "./ReliefVehicle.vue?vue&type=template&id=0de5526c&"
import script from "./ReliefVehicle.vue?vue&type=script&lang=js&"
export * from "./ReliefVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports